export const INITIAL_STATE = {
    displayAmount: false,
    displayArticleSerialNumber: false,
    displayCourier: false,
    displayCustomerRequest: false,
    displayDateOfReceiptOfGoods: false,
    displayFaultDate: false,
    displayFaultDescription: false,
    displayFaultDiscoveryCircumstances: false,
    displayFiles: false,
    displayInvoiceQuantity: false,
    displayProduct: false,
    displayQuantityCorrectionsProposal: false,
    displaySalesDocumentNumber: false,
    displaySalesDocumentPosition: false,
    displayShipmentDescription: false,
    displayShippedQuantity: false,
    displayTermOfUse: false,

    displayArticleIsCompleted:false,
    displayArticleHasDisassemblySigns:false,
    displayMountingAddress:false,
    displayArticlePurchaseAddress:false,
    displayPurchaseProve:false,
    displayPurchaseDate:false,

    
    complaintPositionComponents:[]
};

export const Test_STATE = {
    displayAmount: true,
    displayArticleSerialNumber: true,
    displayCourier: true,
    displayCustomerRequest: true,
    displayDateOfReceiptOfGoods: true,
    displayFaultDate: true,
    displayFaultDescription: true,
    displayFaultDiscoveryCircumstances: true,
    displayFiles: true,
    displayInvoiceQuantity: true,
    displayProduct: true,
    displayQuantityCorrectionsProposal: true,
    displaySalesDocumentNumber: true,
    displaySalesDocumentPosition: true,
    displayShipmentDescription: true,
    displayShippedQuantity: true,
    displayTermOfUse: true,

    displayArticleIsCompleted:true,
    displayArticleHasDisassemblySigns:true,
    displayMountingAddress:true,
    displayArticlePurchaseAddress:true,
    displayPurchaseProve:true,
    displayPurchaseDate:true
};


// WEBPACK FOOTER //
// ./src/reducers/state/ComplaintPositionsComponents.js